export function countryToSelect(countries) {
    let cleanedCountries = [];

    countries.map((item) => (
        cleanedCountries.push({
            label: item.name,
            value: item.id,
            item: item,
        })
    ));

    return cleanedCountries;
}



// WEBPACK FOOTER //
// ./src/utils/country.js